
export default {
  name: 'CompetitionPage',
  props: {
    type: {
      type: Object,
      default: function (): any {
        return {}
      }
    }
  },
  data (): any {
    return {
      dialog: {
        create: false
      },
      data: ''
    }
  }
}
